<template>
	<div class="counter-style-two section-padding">
		<div>
			<div class="container">
				<h2 class="titre-section">
					<span class="span-background">
						NOS FORMATIONS EN QUELQUES CHIFFRES
					</span> <br>
          <span class="italic font-small text-transform-none">(indicateurs année {{ previousYear }})</span>
				</h2>
				<div class="row justify-content-center">
					<div v-for="item in counterData" :key="item.id" class="col-lg-4 col-sm-6" data-aos="fade-up"
						data-aos-duration="1200" :data-aos-delay="item.delay">
						<div class="counter-box-four">
							<img class="img-counter mb-3" :src="item.img" :alt="item.title">
							<p class="title mb-3">{{ item.title }}</p>
							<h2 class="number">
								<span class="timer">
									<span class="chiffre d-flex align-items-center justify-content-center">
										{{ item.value }}
										{{ item.text ? item.text : "" }}
									</span>
								</span>
							</h2>
						</div>
						<!-- /.counter-box-four -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CountUp from "vue-countup-v3";

export default {
	name: "CounterArea",
	components: { CountUp },
	computed: {
		previousYear() {
			return new Date().getFullYear() - 1;
		},
	},
	data() {
		return {
			startCounter: false,
			counterData: [
				{
					id: 1,
					img: "/images/pages/organisme-formation/session-formation.png",
					value: 98,
					title: "Sessions de formation",
					text: "",
				},
				{
					id: 2,
					img: "/images/pages/organisme-formation/satisfaction-formation.png",
					value: 4.80,
					title: "Taux de satisfaction",
					delay: "100",
					text: " / 5",
				},
				{
					id: 3,
					img: "/images/pages/organisme-formation/stagiaire-formation.png",
					value: 528,
					title: "Stagiaires formés",
					delay: "200",
					text: "",
				},
			],
		};
	},
	methods: {
		onChange(waypointState) {
			if (waypointState.going === "IN") {
				this.startCounter = true;
			}
		},
	},
};
</script>


<style scoped>
.titre-section {
	color: var(--accent, #25233E);
	text-align: center;
	font-family: Nunito;
	font-size: 3.125rem;
	/*50 px */
	font-style: normal;
	font-weight: 600;
	line-height: 111.5%;
	letter-spacing: -0.825px;
	text-transform: uppercase;
}

.img-counter {
	display: block;
	margin: auto;
}

.chiffre {
	font-family: Nunito;
}

.title {
	font-family: Inter;
	font-size: 1.3125rem;
	font-style: normal;
	font-weight: 600;
}

.section-padding {
	padding: 5rem 0;
}

.counter-box-four {
	background: white;
	padding: 2rem;
	border-radius: 9px;
}

.italic {
  font-style: italic;
}

.font-small {
  font-size: 1.5rem !important;
}

.text-transform-none {
  text-transform: none !important;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
	.d-flex {
		flex-direction: column;
		width: 100%;
		padding: 10px 10px;
	}

	h2 {
		font-size: 20px !important;
	}

	.w-50 {
		width: 90% !important;
	}
}

/* Pour les appareils entre 768px et 991px de large (tablettes en mode paysage) */
@media only screen and (min-width: 769px) and (max-width: 991px) {}

/* Pour les appareils entre 992px et 1199px de large (tablettes en mode portrait et ordinateurs portables) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {}

/* Pour les appareils de 1200px de large et plus (ordinateurs de bureau) */
@media only screen and (min-width: 1200px) {}
</style>